import React from 'react';

import NewNavbar from '../Components/NewNavbar';
import Head from '../Components/Head';
import NewSkills from '../Components/NewSkills';
import Experience from '../Components/Experience';
import NewEdu from '../Components/NewEdu';
import NewProject from '../Components/NewProject';
import GithubStats from '../Components/GithubStats';
import NewFooter from '../Components/NewFooter';

export default function Home() {
  return (
    <div className="home">
      <NewNavbar />
      <main>
        <Head />
        <NewSkills />
        <Experience />
        <NewEdu />
        <NewProject />
        <GithubStats />
      </main>
      <NewFooter />
    </div>
  );
}
